import { getUserInfo } from "@/apis/user";
import { USER_INFO } from "@/constants";
import { UserInfo } from "@/types/Api/User/MyAccount/userInfo";
import { RequestResponse } from "@/utils/request";
import { create, StoreApi, UseBoundStore } from "zustand";
import { selectorLocalStorage, useLocalStorage } from "./localstorage";
import * as Sentry from '@sentry/react'
export * from "./localstorage";

const initialUserInfo = {
  userId: 0,
  userType: "",
  walletAddress: "",
  userName: "",
  nickname: "",
  realName: "",
  balance: "",
  validSellBalance: "",
  isRealNameAuth: true,
  creditLevel: 0,
  secPasswordStatus: false, //是否设置资金密码
  avatar: "",
  isEnteredPhoneNumber: 0,
  isEnteredPassword: false,
  realNameRemark: "",
  isUserName: 0,
  isGoogleAuthenticator: 0,
  businessBalance: "",
  businessFrozenBalance: "",
  businessAssureBalance: "",
  BusinessStatus: -1,
  sumSellAmount: "",
  sumFrozenAmount: "",
  phone: "",
  preResetPwdTime: "",
  paymentType: 0,
  auditRealNameStatus: -1,
};

interface UserInfoStore {
  userInfo: UserInfo["response"];
  clearUserInfo: () => void;
  setUserInfo: (userInfo?: any) => void;
  updateUserInfo: () => Promise<RequestResponse<UserInfo["response"]>>;
}

type ReturnUseUserInfoStore = UseBoundStore<StoreApi<UserInfoStore>>;

let lazyUserInfoStore: ReturnUseUserInfoStore;

export const useUserInfoStore = (): ReturnUseUserInfoStore => {
  const [user, setUser] =
    useLocalStorage<UserInfo["response"]>(USER_INFO)(selectorLocalStorage);

  if (lazyUserInfoStore === undefined) {
    lazyUserInfoStore = create<UserInfoStore>((set) => ({
      userInfo: user,
      clearUserInfo: () => {
        setUser(initialUserInfo);
        set(() => ({ userInfo: initialUserInfo }));
      },
      setUserInfo: (userInfo = {}) =>
        set((state) => {
          const _userInfo = Object.assign({}, state.userInfo, userInfo);
          setUser(_userInfo);
          return {
            userInfo: _userInfo,
          };
        }),
      updateUserInfo: async () => {
        const response = await getUserInfo({});
        if (response.ok) {
          set((state) => {
            const _userInfo = Object.assign({}, state.userInfo, response.data!);
            Sentry.captureMessage(`设置 ${JSON.stringify(_userInfo)}`,"info");
            setUser(_userInfo);
            return {
              userInfo: _userInfo,
            };
          });
        } else {
          // TODO: 更新用户信息失败
        }
        return response;
      },
    }));
  }

  return lazyUserInfoStore;
};
